import { useCallback } from "react";

import useFTMessage from "hooks/Notification";
import { DYNAMIC_RENDER_MATCHERS } from "utils/renderNotify";


export function useReplayPreviewOnRenderNotify({ creativeId, onReplay, enabled }) {
	const handleFtMessage = useCallback(
		(event) => {
			if (!enabled) {
				return;
			}

			const { message } = event.detail || {};
			const matched = DYNAMIC_RENDER_MATCHERS.find(matcher => matcher.isComplete(message));
			const messageCreativeId = matched && matched?.getCreativeId(message);

			if (!matched || !messageCreativeId || messageCreativeId !== Number(creativeId)) {
				return;
			}

			onReplay();
		},
		[creativeId, enabled, onReplay]
	);

	useFTMessage(handleFtMessage);
}
